import { render } from "./MandateDeleteDialog.vue?vue&type=template&id=21560fdb"
import script from "./MandateDeleteDialog.vue?vue&type=script&lang=js"
export * from "./MandateDeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__